/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：金额格式化工具
 */
const formatMoney = (val, num) => {
  val = Number(val).toFixed(2)
  // val = Number(val).toFixed()
  if (Number(val) > 1) {
    let int = val.split('.')[0]
    let float = val.split('.')[1]
    val = int.replace(/\B(?=(?:\d{3})+$)/g, ',') + '.' + float
    // val = int.replace(/\B(?=(?:\d{3})+$)/g, ',')
  }
  return '¥' + val
}
const install = Vue => {
  if (install.installed) {
    return true
  }
  install.installed = true
  Object.defineProperties(Vue.prototype, {
    $f: {
      get() {
        return formatMoney
      }
    }
  })
}
export default { install }



// WEBPACK FOOTER //
// ./src/plugins/formatMoney.js